import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { keyframes } from "@mui/system";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const slideInRight = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

function NextStepCard({ visible, title, body, buttonText, buttonLink, icon, onDismiss }) {
    const theme = useTheme();

    if (!visible) return null;

    return (
        <MDBox
            position="fixed"
            bottom="24px"
            right="24px"
            borderRadius="xl"
            coloredShadow="dark"
            p={3}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            zIndex={9999}
            sx={{
                maxWidth: "400px",
                border: "2px solid #00A1A1",
                backgroundColor: theme.functions.rgba("#000", 0.6),
                backdropFilter: `saturate(200%) blur(30px)`,
                animation: `${slideInRight} 0.5s ease-out forwards`,
            }}
        >

            {onDismiss && (
                <IconButton
                    size="small"
                    onClick={onDismiss}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "white",
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}

            <MDBox display="flex" alignItems="center" gap={1.5} mb={2} pr={3}>
                <TipsAndUpdatesIcon sx={{ color: "#FFB347" }} />
                <MDTypography variant="h6" fontWeight="bold" color="white">
                    {title}
                </MDTypography>
            </MDBox>

            <MDTypography variant="body2" color="white" opacity={0.8} mb={3}>
                <span dangerouslySetInnerHTML={{ __html: body }} />
            </MDTypography>

            <MDButton
                component={Link}
                to={buttonLink}
                variant="gradient"
                color="accent"
                fullWidth
                startIcon={icon}
                sx={{
                    fontWeight: "bold",
                    boxShadow: "0 0 15px rgba(255, 179, 71, 0.4)"
                }}
            >
                {buttonText}
            </MDButton>
        </MDBox>
    );
}

NextStepCard.propTypes = {
    visible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
    icon: PropTypes.element,
    onDismiss: PropTypes.func, // Optional
};

export default NextStepCard;
